import {useSearchParams} from 'react-router-dom';
import {useCallback, useMemo} from 'react';
import {SingleValue} from 'react-select';
import {LocationType} from '../../../gql/pwa/graphql.ts';

interface LocationOption {
    label: string | null | undefined;
    value: number | null | undefined;
}
export function useLocations(
    locations: Array<LocationType | null> | null | undefined,
    selectedLocation: number | undefined,
) {
    const locationOptions: LocationOption[] = useMemo(() => {
        return (
            locations
                ?.filter((b): b is NonNullable<typeof b> => b != null)
                .map((b) => {
                    return {
                        value: b.id,
                        label: b.name,
                        meta: b,
                    };
                }) ?? []
        );
    }, [locations]);

    const selectedLocationOption: LocationOption | null = useMemo(
        () => locationOptions?.find((to) => to.value === selectedLocation) ?? null,
        [locationOptions, selectedLocation],
    );

    const [, setSearchParams] = useSearchParams();
    const onSetLocationCallback = useCallback(
        (value: SingleValue<LocationOption>) => {
            setSearchParams((current) => {
                if (value?.value) {
                    current.set('location_id', value.value.toString());
                } else {
                    current.delete('location_id');
                }
                current.delete('page');
                return current;
            });
        },
        [setSearchParams],
    );

    return {
        locationOptions,
        selectedLocationOption,
        onSetLocationCallback,
    };
}
